import React from 'react';
import QuickCash from '../views/quickCash.c';
import Salary from '../views/salary.c';
import Installment from '../views/installment.c';
import List from '../views/credits_new.c';
import Pbp from '../views/pbp.c';
import NewInstallment from '../../NewInstallment/view/newInstallment.c'
import DepositCreditOrdinary from '../views/depositCreditOrdinary.c'
import InstallmentFromStatement from '../views/installment_from_statement.c'
import Vygoda from '../components/Vygoda/views/main.c'
import CreditAuto from '../components/СreditAuto/views/main.c'

import GoogleTagManager from '../../../services/GoogleTagManager';
import InstantInstallment from "../views/instantInstallment.c";
import InstantCash from '../components/InstantCash/views/main.c';
import CreditDebt from '../components/CreditDebt/views/main.c';

export default function template() {
    let Component = null;

    if (this.props.match && this.props.match.params && this.props.match.params.type) {
        switch (this.props.match.params.type) {
            case 'quick_cash':
                Component = QuickCash;
                break;
            case 'gdz':
                Component = Salary;
                break;
            case 'installment':
                Component = Installment;
                break;
            case 'pbp':
                Component = Pbp;
                break;
            case 'instant_installment':
                Component = InstantInstallment;
                break;
            case 'new_installment':
                Component = NewInstallment;
                break;
            case 'deposit_credit':
                Component = DepositCreditOrdinary;
                break;
            case 'installment_from_statement':
                Component = InstallmentFromStatement;
                break;
            case 'vygoda':
                Component = Vygoda;
                break;
            case 'money_auto':
                Component = CreditAuto;
                break;
            case 'credit_debt':
                Component = CreditDebt;
                break;
            case 'instant_cash':
                Component = InstantCash;
                break;
        }
    } else {
        Component = List;
    }

    return (
        <div className="module-credit">
            {/* <GoogleTagManager gtmId='GTM-PJL9JV5' scriptId='scriptId' dataLayerName='dataLayer' additionalEvents={event} previewVariables='' />*/}
            <Component {...this.props} />
        </div>
    );
}
